import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').config(landingPageRoute);

    /** @ngInject */
    function landingPageRoute($stateProvider) {
        $stateProvider.state('langing_page', {
            url: '/',
            template: require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/landing_page/landing_page.html'),
            controller: 'LandingPageController',
            controllerAs: 'LandingPageCtrl',
        });
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/landing_page/landing_page.route.ts